import styled from "styled-components";

export const MarkdownContainer = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  color: #333;

  h1 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;
    color: #1a1a1a;
    border-bottom: 3px solid #e1e5e9;
    padding-bottom: 20px;
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 40px 0 20px 0;
    color: #2c3e50;
    border-bottom: 2px solid #e1e5e9;
    padding-bottom: 10px;
  }

  h3 {
    font-size: 20px;
    font-weight: 600;
    margin: 30px 0 15px 0;
    color: #34495e;
  }

  p {
    margin-bottom: 16px;
    color: #4a5568;
    line-height: 1.7;
  }

  ol {
    margin: 16px 0;
    padding-left: 30px;
    
    li {
      margin-bottom: 12px;
      line-height: 1.7;
      color: #4a5568;
    }

    ol {
      margin: 8px 0;
      
      li {
        margin-bottom: 8px;
      }
    }
  }

  ul {
    margin: 16px 0;
    padding-left: 30px;
    
    li {
      margin-bottom: 8px;
      line-height: 1.7;
      color: #4a5568;
    }
  }

  strong {
    font-weight: 600;
    color: #2d3748;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    
    th, td {
      border: 1px solid #e1e5e9;
      padding: 12px;
      text-align: left;
      line-height: 1.5;
    }
    
    th {
      background-color: #f8f9fa;
      font-weight: 600;
      color: #2c3e50;
    }
    
    td {
      color: #4a5568;
    }
  }

  hr {
    border: none;
    border-top: 1px solid #e1e5e9;
    margin: 40px 0;
  }

  /* 반응형 */
  @media (max-width: 768px) {
    padding: 20px 16px;

    h1 {
      font-size: 28px;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 22px;
      margin: 30px 0 15px 0;
    }

    h3 {
      font-size: 18px;
      margin: 25px 0 12px 0;
    }

    ol, ul {
      padding-left: 20px;
    }
    
    table {
      font-size: 14px;
      
      th, td {
        padding: 8px;
      }
    }
  }

  @media (max-width: 480px) {
    table {
      font-size: 12px;
      
      th, td {
        padding: 6px;
      }
    }
  }
`;
